import { alpha } from "@mui/material/styles";
import { listClasses } from "@mui/material/List";
import { paperClasses } from "@mui/material/Paper";
import { buttonClasses } from "@mui/material/Button";
import { listItemIconClasses } from "@mui/material/ListItemIcon";
import { tablePaginationClasses } from "@mui/material/TablePagination";
//
import { paper } from "../../css";
// ----------------------------------------------------------------------
export function dataGrid(theme) {
    const paperStyles = paper({ theme, dropdown: true });
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    borderWidth: 0,
                    backgroundColor: "transparent",
                    "& .MuiDataGrid-filler > div": {
                        borderTop: "none !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#F4F6F8",
                        borderRadius: "24px 24px 8px 8px",
                        // boxShadow: "0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33",
                        overflow: "hidden",
                        // marginBottom: "8px",
                    },
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "#F4F6F8",
                    },
                    "& .MuiDataGrid-cell": {
                        border: "none !important",
                        // minHeight: "78px !important",
                        display: "flex !important",
                        alignItems: "center !important",
                    },
                    "& .MuiSvgIcon-root ": {
                        color: "rgba(69, 79, 91, 1)",
                    },
                    // "& .MuiDataGrid-virtualScrollerContent": {
                    //   backgroundColor: "#FFFFFF",
                    //   // boxShadow:
                    //   //   "0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33",
                    //   // borderRadius: "24px",
                    //   border:'1px solid transparent'
                    // },
                    "& .MuiDataGrid-row": {
                        cursor: "pointer",
                        border: "1px solid transparent",
                        // minHeight: "76px !important",
                        "&:nth-of-type(even)": {
                            borderBottom: "1px solid transparent",
                        },
                        "&:nth-of-type(odd)": {
                            borderBottom: "1px solid transparent",
                        },
                        "&:first-of-type": {
                            borderTop: "1px solid transparent",
                            borderTopLeftRadius: 24,
                            borderTopRightRadius: 24,
                        },
                        "&:last-of-type": {
                            borderBottom: "1px solid transparent",
                            borderBottomLeftRadius: 24,
                            borderBottomRightRadius: 24,
                        },
                    },
                    "& .MuiDataGrid-columnHeaderTitleContainer": {
                        overflow: "hidden",
                        minWidth: 0,
                    },
                    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
                        overflow: "hidden",
                        minWidth: 0,
                        flex: 1,
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        fontWeight: "500 !important",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontSize: "14px !important",
                        color: "#063C79",
                    },
                    [`& .${tablePaginationClasses.root}`]: {
                        borderTop: 0,
                        color: theme.palette.tertiary[40],
                        background: "trasnparent",
                        boxShadow: "none",
                        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                            color: theme.palette.tertiary[40],
                        },
                        "& .MuiIconButton-root": {
                            color: theme.palette.tertiary[40],
                            "& .MuiSvgIcon-root": {
                                color: theme.palette.tertiary[40],
                            },
                        },
                        // Greyed-out arrows when prev/next page is unavailable (matches plain table)
                        "& .MuiIconButton-root.Mui-disabled, & .MuiIconButton-root:disabled": {
                            color: `${theme.palette.action.disabled} !important`,
                            "& .MuiSvgIcon-root": {
                                color: `${theme.palette.action.disabled} !important`,
                            },
                        },
                    },
                    [`& .${tablePaginationClasses.toolbar}`]: {
                        height: "40px",
                        color: theme.palette.tertiary[40],
                    },
                    "& .MuiDataGrid-row.Mui-selected": {
                        backgroundColor: alpha(theme.palette.primary.main, 0.2),
                    },
                    "& .MuiDataGrid-withBorderColor": {
                        border: "1px solid transparent",
                    },
                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                        outline: "none",
                    },
                    "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
                        outline: "none",
                    },
                    // Scrollbar: hidden by default, revealed on hover of the grid
                    // (matches the native-table hover behaviour in App.css)
                    "& .MuiDataGrid-scrollbar": {
                        scrollbarWidth: "thin",
                        scrollbarColor: "transparent transparent",
                        "&::-webkit-scrollbar": {
                            width: 6,
                            height: 6,
                            backgroundColor: "transparent",
                        },
                        "&::-webkit-scrollbar-track": {
                            backgroundColor: "transparent",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "transparent",
                            borderRadius: 3,
                            transition: "background-color 0.3s ease-in-out",
                        },
                    },
                    "&:hover .MuiDataGrid-scrollbar": {
                        scrollbarColor: "rgba(0, 0, 0, 0.32) transparent",
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "rgba(0, 0, 0, 0.32)",
                        },
                    },
                },
                cell: {
                    borderBottom: `1px dashed transparent`,
                },
                selectedRowCount: {
                    whiteSpace: "nowrap",
                },
                columnSeparator: {
                    color: theme.palette.divider,
                    display: "none",
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    borderBottom: `1px dashed ${theme.palette.divider}`,
                    height: "40px",
                    backgroundColor: theme.palette.background.neutral,
                },
                paper: Object.assign(Object.assign({}, paperStyles), { padding: 0 }),
                menu: {
                    [`& .${paperClasses.root}`]: Object.assign({}, paperStyles),
                    [`& .${listClasses.root}`]: {
                        padding: 0,
                        [`& .${listItemIconClasses.root}`]: {
                            minWidth: 0,
                            marginRight: theme.spacing(2),
                        },
                    },
                },
                panelHeader: {
                    padding: theme.spacing(2),
                },
                footerContainer: {
                    // marginTop: 8,
                    borderRadius: "8px 8px 24px 24px",
                    // boxShadow: "0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33",
                    minHeight: 56,
                    background: theme.palette.background.neutral,
                    fontSize: "14px",
                    color: "#00244D",
                    // "& *": {
                    //   color:'#00244D',
                    //   fontSize: "14px !important",
                    // },
                    // Restore pagination prev/next arrow icon size to match plain-table arrows
                    "& .MuiTablePagination-actions .MuiIconButton-root .MuiSvgIcon-root": {
                        fontSize: "1.5rem !important",
                    },
                },
                panelFooter: {
                    padding: theme.spacing(2),
                    justifyContent: "flex-end",
                    borderTop: `dashed 1px transparent`,
                    [`& .${buttonClasses.root}`]: {
                        "&:first-of-type": {},
                        "&:last-of-type": {
                            marginLeft: theme.spacing(1.5),
                            color: theme.palette.background.paper,
                            backgroundColor: theme.palette.text.primary,
                        },
                    },
                },
                filterForm: {
                    padding: theme.spacing(2),
                },
                filterFormValueInput: {
                    marginLeft: theme.spacing(2),
                },
                filterFormColumnInput: {
                    marginLeft: theme.spacing(2),
                },
                filterFormOperatorInput: {
                    marginLeft: theme.spacing(2),
                },
            },
        },
    };
}
